import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import styled from 'styled-components';
import { errorProps } from './props';

const { Option, OptGroup } = Select;
// Width is temporary until better solution is found
const StyledDropdown = styled(Select)`
  font-size: 16px;
  font-weight: 400;
  ${p => p.width && `width: ${p.width} !important;`}
  .ant-select-selection {
    ${errorProps};
  }

  .ant-select-selection__clear {
    width: 16px;
    height: 16px;
    right: 30px !important;
  }
`;
// since antd form uses ref, we need a class component
// eslint-disable-next-line
class Dropdown extends Component {
  static propTypes = {
    values: PropTypes.array,
    showSearch: PropTypes.bool,
    valueKey: PropTypes.string,
    valueLabel: PropTypes.string,
    isGrouped: PropTypes.bool,
    groups: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        filter: PropTypes.func.isRequired,
      }),
    ),
    loading: PropTypes.bool,
    multiSelect: PropTypes.bool,
    renderOption: PropTypes.func,
    className: PropTypes.string,
    width: PropTypes.number,
  };

  createDropdownClassName = () => {
    const { className = '' } = this.props;
    return className
      .split(' ')
      ?.filter(s => s)
      ?.map(s => `${s}__dropdown`)
      .join(' ');
  };

  renderValues = () => {
    const {
      isGrouped = false,
      groups,
      values,
      renderOption,
      valueKey = 'id',
      valueLabel = 'text',
    } = this.props;
    if (!values || !values.length) {
      return null;
    }

    if (isGrouped) {
      return groups?.map(group =>
        <OptGroup key={group.id} label={group.name}>
          {values
            ?.filter(e => group?.filter(e))
            ?.map(v =>
              <Option value={v[valueKey]} key={v[valueKey]}>
                {v[valueLabel]}
              </Option>,
            )}
        </OptGroup>,
      );
    }
    if (renderOption) {
      return values?.map(renderOption);
    }
    return values?.map(v =>
      <Option value={v[valueKey]} key={v[valueKey]}>
        {v[valueLabel] || v[valueKey]}
      </Option>,
    );
  };

  render() {
    const { multiSelect, width, showSearch = true, ...rest } = this.props;

    return (
      <StyledDropdown
        popupClassName={this.createDropdownClassName()}
        getPopupContainer={triggerNode => triggerNode.parentNode}
        showSearch={showSearch}
        width={width}
        mode={multiSelect ? 'multiple' : null}
        filterOption={(value, option) =>
          option.children && option.children
            ?.toString()
            ?.toLowerCase()
            ?.indexOf(value.toLowerCase()) >= 0
        }
        {...rest}
      >
        {this.renderValues()}
      </StyledDropdown>
    );
  }
}

export default Dropdown;
